import React, { FC } from 'react';

import { CommonError } from 'src/components/common-error';
import { i18n } from 'src/i18n';
import { owlImageProps } from 'src/resources/images';

export const PageRestrictedPurchase: FC = () => (
  <CommonError
    title={i18n.page.error.restrictedPurchase.title}
    subtitle={i18n.page.error.restrictedPurchase.description}
    image={owlImageProps}
  />
);
